<template>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="800px" @close="handleClose"
        :close-on-click-modal="false" top="5vh">
        <el-form :model="form" :rules="rules" ref="formRef" label-width="150px">
            <el-form-item label="企业名称" prop="companyName">
                <el-input disabled v-model="form.companyName" placeholder="请输入企业名称" clearable />
            </el-form-item>

            <!-- 社会信用代码 -->
            <el-form-item label="社会信用代码" prop="socialCreditId">
                <el-input disabled v-model="form.socialCreditId" placeholder="请输入统一社会信用代码" clearable />
            </el-form-item>

            <!-- 联系方式 -->
            <el-form-item label="法人姓名" prop="bossName">
                <el-input disabled v-model="form.bossName" placeholder="请输入法人姓名" clearable />
            </el-form-item>

            <!-- 联系方式 -->
            <el-form-item label="联系方式" prop="bossPhone">
                <el-input disabled v-model="form.bossPhone" placeholder="请输入联系电话作为主账号" clearable />
            </el-form-item>

            <!-- 联系人姓名 -->
            <el-form-item label="联系人姓名" prop="contactName">
                <el-input disabled v-model="form.contactName" placeholder="请输入联系人姓名" clearable />
            </el-form-item>

            <!-- 联系人电话 -->
            <el-form-item label="联系人电话" prop="contactPhone">
                <el-input disabled v-model="form.contactPhone" placeholder="请输入联系人电话" clearable />
            </el-form-item>

            <!-- 对公账户 -->
            <el-form-item label="对公账户" prop="companyBankId">
                <el-input disabled v-model="form.companyBankId" placeholder="请输入对公账户" clearable />
            </el-form-item>

            <!-- 所在街道 -->
            <el-form-item label="所在街道" prop="areaCode">
                <el-input disabled v-model="form.address" placeholder="请输入所在街道" clearable />
            </el-form-item>

            <el-form-item label="法人身份证人像面" prop="bossCardFront">
                <el-image class="image-size" fit="contain" :src="form.bossCardFront
                    ? baseUrl + 'admin/file/get?ossFilePath=' + form.bossCardFront
                    : 'imgs/card-1.png'"></el-image>
            </el-form-item>

            <el-form-item label="法人身份证国徽面" prop="bossCardBack">
                <el-image class="image-size" fit="contain" :src="form.bossCardBack
                    ? baseUrl + 'admin/file/get?ossFilePath=' + form.bossCardBack
                    : 'imgs/card-2.png'"></el-image>
            </el-form-item>

            <el-form-item label="营业执照" prop="businessLicense">
                <el-image class="image-size" fit="contain"
                    :src="baseUrl + 'admin/file/get?ossFilePath=' + form.businessLicense">
                    <div slot="error"
                        style="width: 100%;height: 100%;  display: flex;  align-items: center; justify-content: center;  background-color: #f5f7fa">
                        <i style=" font-size: 32px;  color: #c0c4cc;" class="el-icon-picture-outline"></i>
                    </div>
                </el-image>
            </el-form-item>

            <!-- 园区特色标签 -->
            <el-form-item label="企业特色标签" prop="labels">
                <el-input :disabled="inputDisabled" v-model="form.labels[0]" placeholder="请输入特色标签" clearable
                    style="width: 150px" />
                <el-input :disabled="inputDisabled" v-model="form.labels[1]" placeholder="请输入特色标签" clearable
                    style="width: 150px; margin-left: 10px" />
            </el-form-item>

            <!-- 概要介绍（带字数统计） -->
            <el-form-item label="概要介绍 (50字)" prop="summary">
                <el-input :disabled="inputDisabled" v-model="form.summary" placeholder="请输入企业概要介绍" clearable
                    @input="handleSummaryInput" />
                <div style="text-align: right; font-size: 12px; color: #999">
                    还可输入 {{ remainingChars }} 个字
                </div>
            </el-form-item>

            <!-- 园区简介（富文本） v-if="dialogVisible"用于刷新组件 重新加载-->
            <el-form-item label="企业简介" prop="introduction">
                <vue-editor :disabled="inputDisabled" v-if="dialogVisible" v-model="form.introduction"
                    useCustomImageHandler @image-added="handleImageAdded" />
            </el-form-item>

            <!-- 园区位置标记（Leaflet 地图） v-if="dialogVisible"用于刷新组件 重新加载-->
            <el-form-item label="企业位置标记" prop="centerPoint">
                <div v-if="dialogVisible" id="map_container" style="height: 300px;"></div>
            </el-form-item>
        </el-form>
        <!-- 底部按钮 -->
        <template v-if="type != 'view'" #footer>
            <span class="dialog-footer">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" :loading="submitLoading" :disabled="submitLoading"
                    @click="handleSubmit">提交</el-button>
            </span>
        </template>

    </el-dialog>
</template>

<script>
import { initMap, clearMarkers } from '@/utils/mapUtil/funcs'
import { findDetailByCompanyId, updateCompanyContentByCompanyId } from "@/api/projectManage";
import { wgs84togcj02, gcj02towgs84 } from 'coordtransform'
import { uploadFile } from "@/api/fileApi";
import { VueEditor } from "vue2-editor"

export default {
    components: {
        VueEditor
    },
    props: {
        dialogTitle: {
            type: String,
            default: ''
        },
        companyId: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            dialogVisible: false,
            form: {
                companyId: null,
                companyName: "",
                socialCreditId: "",
                bossName: "",
                bossPhone: "",
                contactName: "",
                contactPhone: "",
                companyBankId: "",
                areaCode: "",
                address: "",
                bossCardFront: "",
                bossCardBack: "",
                businessLicense: "",
                labels: [],
                summary: "",
                introduction: "",
                centerPoint: []
            },
            initForm: {},
            remainingChars: 50, // 剩余可输入字数
            submitLoading: false,
            map: null,
            marker: null,

            /******************/

            baseUrl: window.globalUrl.HOME_API,

            rules: {
                summary: [
                    { max: 50, message: '不超过50字', trigger: 'blur' }
                ]
            }
        };
    },
    created() {
        this.initForm = { ...this.form }
    },
    watch: {
        // 监听弹窗显示状态，初始化地图
        dialogVisible(val) {
            if (val) {
                this.$nextTick(async () => {
                    await this.initData()
                    this.initMap();
                    this.bindMapClick();
                })
            } else {
                this.unbindMapClick();
            }
        }
    },
    computed: {
        inputDisabled() {
            return this.type === 'view'
        }
    },
    methods: {

        async handleImageAdded(file, Editor, cursorLocation, resetUploader) {
            const formData = new FormData()
            formData.append("file", file)
            formData.append("catalog", "park-management");
            try {
                let res = await uploadFile(formData);
                // let fileName = res.data.sourceFileName;
                let url = window.globalUrl.HOME_API + "/admin/file/get?ossFilePath=" + res.data.url;
                Editor.insertEmbed(cursorLocation, "image", url)
                resetUploader()
            } catch (err) {
                console.error(err)
            }
        },

        // 绑定地图点击事件
        bindMapClick() {
            if (!this.map) return;
            this.map.on('click', this.handleMapClick);
        },

        // 解绑地图点击事件
        unbindMapClick() {
            if (!this.map) return;
            this.map.off('click', this.handleMapClick);
        },

        // 点击地图时的处理
        handleMapClick(e) {
            let wgs84lat = e.latlng.lat
            let wgs84lng = e.latlng.lng
            clearMarkers(this.map.tempLayer)
            this.marker = L.marker([wgs84lat, wgs84lng]).addTo(this.map.tempLayer);
            const [gcjlng, gcjlat] = wgs84togcj02(wgs84lng, wgs84lat)
            this.form.centerPoint = [gcjlng,gcjlat]
        },

        // 初始化地图
        initMap() {
            this.map = initMap("map_container")
            this.setMarker(this.form.centerPoint[0], this.form.centerPoint[1])
        },

        async initData() {
            let res = await findDetailByCompanyId({ companyId: this.companyId });
            if (res.success) {
                //返回的经纬度
                // console.log(res.data, 'res.data')
                this.form = res.data
                this.form.labels = res.data.labels || []
                this.form.centerPoint = res.data.centerPoint || []
            }
        },

        // 设置标记并缩放地图(纬经度)
        setMarker(lng,lat) {
            clearMarkers(this.map.tempLayer)
            const [wgs84lng, wgs84lat] = gcj02towgs84(lng, lat)
            this.marker = L.marker([wgs84lat, wgs84lng]).addTo(this.map.tempLayer);
            this.map.setView([wgs84lat, wgs84lng], 13);
        },

        // 概要介绍输入监听，计算剩余字数
        handleSummaryInput() {
            const maxLength = 50;
            const currentLength = this.form.summary.length;
            this.remainingChars = maxLength - currentLength;
        },

        // 提交按钮
        handleSubmit() {
            this.$refs.formRef.validate(async (valid) => {
                if (valid) {
                    // 开始提交，锁定按钮
                    this.submitLoading = true;
                    try {
                        let dto = {
                            companyId: this.form.companyId,
                            labels: this.form.labels||[],
                            summary: this.form.summary,
                            introduction: this.form.introduction,
                            centerPoint:this.form.centerPoint||[],
                        }
                        // console.log(dto, 'dto-------')
                        let res = await updateCompanyContentByCompanyId(dto);
                        if (res.success) {
                            this.$message.success("操作成功");
                            this.handleClose()
                            this.$emit('load')
                        } else {
                            this.$message.error(res.msg);
                        }
                    } catch (error) {
                        console.error("提交失败:", error);
                    } finally {
                        this.submitLoading = false;
                    }
                }
            });
        },

        // 关闭弹窗回调
        handleClose() {
            this.resetForm();
            this.dialogVisible = false;
        },

        // 重置表单
        resetForm() {
            this.$nextTick(() => {
                this.$refs.formRef.clearValidate()
            })
            this.form = { ...this.initForm }
            this.form.labels = []
            this.remainingChars = 50;
            if (this.marker) {
                this.map.tempLayer.removeLayer(this.marker);
                this.marker = null;
            }
        }
    },
};
</script>

<style lang="less" scoped>
.image-size {
    width: 148px;
    height: 105px;
}

.image-error {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #f5f7fa;
    color: #909399;
}

.image-error i {
    font-size: 24px;
    margin-bottom: 5px;
}

.image-error span {
    font-size: 12px;
}

/deep/.el-form-item__content {
    text-align: left;
}

/deep/.el-loading-spinner {
    // text-align: left;
    width: 39% !important;
}

/deep/.el-loading-text {
    // text-align: left;
    margin-top: -29px;
}
</style>